export default {
  workspace: (state) => state.workspace,
  lastOpenedWorkspace: (state) => parseInt(state.lastOpenedWorkspace) || parseInt(localStorage.getItem('lastOpenedWorkspace')) || 0,
  version: (state) => state.version,
  versionList: (state) => state.versionList,
  isVersionCopying: (state) => state.isVersionCopying,
  isWorkspaceCopying: (state) => state.isWorkspaceCopying,
  token: (state) => state.token || localStorage.getItem('token'),
  asuToken: (state) => state.asuToken || localStorage.getItem('asuToken'),
  workspaceList: (state) => state.workspaceList,
  activeWorkspaceList: (state) =>
    state.activeWorkspaceList.map((v) => {
      return {
        ...v,
        fullName: `[${v.id}] ${v.name}`
      }
    }),
  lastTimeVersionRequest: (state) => state.lastTimeVersionRequest,
  versionRequestInterval: (state) => state.versionRequestInterval,
  newVersionExists: (state) => state.newVersionExists,
  canEditWs: (state) => {
    const currentWs = state.activeWorkspaceList ? state.activeWorkspaceList.filter((v) => v.id === state.workspace) : null
    return currentWs && currentWs[0] ? currentWs[0].can_edit : false
  },

  /**
   * Права пользователя
   * предлагается использовать этот геттер в компонентах
   * дополнять возвращаемый объект полями по мере необходимости ограничения элементов интерфейса
   * @param {*} state
   * @returns
   */
  permissions: (state) => {
    return {
      canCreateWs: state.permissions.includes('can_create_workspace'),
      canDeleteWs: state.permissions.includes('can_delete_workspace'),

      canCreateControl: state.permissions.includes('can_create_control'),
      canDeleteControl: state.permissions.includes('can_delete_control'),
      canEditControl: state.permissions.includes('can_edit_control'),
      canReadControl: state.permissions.includes('can_read_control'),

      canCreateDataVersion: state.permissions.includes('can_create_dataversion'),
      canDeleteDataVersion: state.permissions.includes('can_delete_dataversion'),
      canEditDataVersion: state.permissions.includes('can_edit_dataversion'),
      canReadDataVersion: state.permissions.includes('can_read_dataversion'),

      canCreateTerschema: state.permissions.includes('can_create_terschema'),
      canDeleteTerschema: state.permissions.includes('can_delete_terschema'),
      canEditTerschema: state.permissions.includes('can_edit_terschema'),
      canReadTerschema: state.permissions.includes('can_read_terschema'),

      canCreateAggregateInfoLayer: state.permissions.includes('can_create_aggregateinfolayer'),
      canDeleteAggregateInfoLayer: state.permissions.includes('can_delete_aggregateinfolayer'),
      canEditAggregateInfoLayer: state.permissions.includes('can_edit_aggregateinfolayer'),
      canReadAggregateInfoLayer: state.permissions.includes('can_read_aggregateinfolayer')
    }
  },

  /**Данные пользователя */
  userData: (state) => {
    return {
      id: state.userId,
      name: state.userName,
      groups: state.userGroups,
      departments: state.userDepartments,
      availableVersions: state.userAvailableVersions
    }
  },

  userId: (state) => {
    return state.userId
  },

  /**
   * Достигнут предел по количеству версий рабочих пространств
   * @param {*} state
   * @param {*} getters
   * @returns
   */
  wsLimitReached: (state, getters) => {
    const userData = getters.userData

    if (Array.isArray(userData.departments) && userData.departments.length > 0) {
      return userData.availableVersions <= 0
    }

    return false
  }
}



// WEBPACK FOOTER //
// ./src/store/auth/getters.js